// extracted by mini-css-extract-plugin
export default {"list":"list_list__J3yCe","horizontal":"list_horizontal__k45vB","vertical":"list_vertical__WWGWi","container":"list_container__FDGFf"};